import styled from "styled-components";

export default styled.label`
  display: block;
  font-size: 15px;
  font-weight: 300;
  color: #585858;
  margin-bottom: 5px;
`